import React, { useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import moment from "moment";
import HelpDeskService from "../../services/helpdesk.services";

import Select from "react-select";

import { Form } from "react-bootstrap";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditFeedback = ({
  editFeedback,
  setEditFeedback,
  issueData,
  fetchAllIsues,
  issueTypes,
}) => {
  const [validated, setValidated] = useState(false);

  const initialData = {
    id: "",
    issue: "",
    description: "",
    date: "",
    formatedDate: "",
  };

  const [details, setDetails] = useState(initialData);
  const [date, setDate] = useState("");

  const currentDate = new Date();

  const handleChange = (e) => {
    setDate(e.value);
    setDetails({
      ...details,
      date: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  const handleSelect = (e) => {
    setDetails({ ...details, issue: e });
  };

  const handleChangeDesc = (e) => {
    setDetails({ ...details, description: e.target.value });
  };

  useEffect(() => {
    setDetails({
      id: issueData.id,
      issue: issueData.helptype,
      description: issueData.description,
      date: moment(issueData.issuedate, "DD-MM-YYYY HH:mm:ss").format(
        "YYYY-MM-DD"
      ),
      formatedDate: moment(issueData.issuedate, "DD-MM-YYYY HH:mm:ss").format(
        "D MMM YYYY"
      ),
    });
    setDate(
      new Date(
        moment(issueData.issuedate, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD")
      )
    );
  }, [issueData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const data = {
      id: details.id,
      helptype: details.issue,
      description: details.description,
      issuedate: details.date,
    };

    HelpDeskService.updateHelpIsuues(data)
      .then((resp) => {
        if (resp.data) {
          setDetails(initialData);
          fetchAllIsues();
          toast.success("Issue Updated Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => setEditFeedback(false),
          });
        }
      })
      .catch((e) => console.log(e));
  };

  // console.log("details", details);
  return (
    <>
      <div
        className={`${
          editFeedback
            ? "add-event feedback visible"
            : "add-event feedback hidden"
        }`}
      >
        <ToastContainer />
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className="flex mb-5">
            <div className="left-flex mb-4">
              <span className="icon">
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.334 1.83325C32.3716 1.83325 34.834 4.29569 34.834 7.33325C34.834 8.34577 34.0132 9.16658 33.0007 9.16658C31.9881 9.16658 31.1673 8.34577 31.1673 7.33325C31.1673 6.32074 30.3465 5.49992 29.334 5.49992H7.33398C6.32147 5.49992 5.50065 6.32074 5.50065 7.33325V36.6666C5.50065 37.6791 6.32147 38.4999 7.33398 38.4999H29.334C30.3465 38.4999 31.1673 37.6791 31.1673 36.6666V34.8333C31.1673 33.8207 31.9881 32.9999 33.0007 32.9999C34.0132 32.9999 34.834 33.8207 34.834 34.8333V36.6666C34.834 39.7042 32.3716 42.1666 29.334 42.1666H7.33398C4.29643 42.1666 1.83398 39.7042 1.83398 36.6666V7.33325C1.83398 4.29569 4.29643 1.83325 7.33398 1.83325H29.334Z"
                    fill="#222125"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.1315 15.035C37.5819 14.4853 36.6907 14.4853 36.1409 15.035L21.8469 29.3292C21.5767 29.5992 21.3976 29.9472 21.3349 30.3241L21.0333 32.1333L22.8424 31.8317C23.2193 31.769 23.5673 31.5899 23.8374 31.3198L38.1315 17.0256C38.6813 16.4759 38.6813 15.5847 38.1315 15.035ZM33.5482 12.4423C35.5298 10.4607 38.7427 10.4606 40.7244 12.4423C42.7058 14.4239 42.7058 17.6367 40.7244 19.6184L26.4302 33.9125C25.6195 34.723 24.576 35.26 23.4452 35.4485L21.6361 35.7501C19.1545 36.1637 17.0029 34.0122 17.4165 31.5305L17.718 29.7213C17.9065 28.5905 18.4435 27.547 19.254 26.7363L33.5482 12.4423Z"
                    fill="#222125"
                  />
                  <path
                    d="M9.16602 12.8333C9.16602 11.8208 9.98684 11 10.9993 11H25.666C26.6786 11 27.4993 11.8208 27.4993 12.8333C27.4993 13.8458 26.6786 14.6667 25.666 14.6667H10.9993C9.98684 14.6667 9.16602 13.8458 9.16602 12.8333Z"
                    fill="#222125"
                  />
                  <path
                    d="M9.16602 20.1666C9.16602 19.154 9.98684 18.3333 10.9993 18.3333H18.3327C19.3452 18.3333 20.166 19.154 20.166 20.1666C20.166 21.1791 19.3452 21.9999 18.3327 21.9999H10.9993C9.98684 21.9999 9.16602 21.1791 9.16602 20.1666Z"
                    fill="#222125"
                  />
                  <path
                    d="M9.16602 27.5001C9.16602 26.4875 9.98684 25.6667 10.9993 25.6667H12.8327C13.8452 25.6667 14.666 26.4875 14.666 27.5001C14.666 28.5126 13.8452 29.3334 12.8327 29.3334H10.9993C9.98684 29.3334 9.16602 28.5126 9.16602 27.5001Z"
                    fill="#222125"
                  />
                </svg>
              </span>
              <span>Update Issue </span>
            </div>

            <div className="event-form">
              <div className="mb-3 select">
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      height: "45px",
                      fontSize: "16px",
                      lineHeight: "20px",
                      fontWeight: "500",
                      border: "1px solid rgba(210, 205, 218, 1)",
                    }),
                    option: (baseStyles, { isFocused, isSelected }) => ({
                      ...baseStyles,
                      fontSize: "16px",
                      lineHeight: "20px",
                      fontWeight: "500",
                      borderRadius: "4px",
                      backgroundColor: isSelected
                        ? "rgba(177, 206, 251, 1)"
                        : isFocused
                        ? "rgba(177, 206, 251, 1)"
                        : "rgba(255, 255, 255, 1)",
                      color: isSelected
                        ? "rgba(78, 70, 94, 1)"
                        : isFocused
                        ? "rgba(78, 70, 94, 1)"
                        : "rgba(78, 70, 94, 1)",
                    }),
                    menu: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                    }),
                  }}
                  options={issueTypes}
                  onChange={handleSelect}
                  value={
                    Array.isArray(issueTypes)
                      ? issueTypes.filter(
                          (option) =>
                            details.issue &&
                            details.issue.includes(option.value)
                        )
                      : []
                  }
                />
              </div>
              <div className="mb-3">
                <textarea
                  placeholder="Give information"
                  name="description"
                  value={details.description}
                  onChange={handleChangeDesc}
                ></textarea>
              </div>
              <div className="mb-3 calendar-relative">
                <label htmlFor="leaveType" className="form-label">
                  Date
                </label>
                <Calendar
                  value={date}
                  onChange={handleChange}
                  view="date"
                  dateFormat="dd, MM, yy"
                  style={{ width: "100%", height: "45px" }}
                  showIcon
                  maxDate={currentDate}
                />
              </div>
            </div>
          </div>

          <div className="event-action">
            <button className="fill">Send</button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default EditFeedback;
